<div class="feedback-header-wrapper">
  @if (icon) {
    <ui-asset class="feedback-header-icon" [class]="feedbackTypeClass" [name]="icon" />
  }
  <div
    class="feedback-header-title title-xs"
    [uiMaskPii]="!!shouldMaskPii"
    [innerHTML]="title | translate: translationParams"
  ></div>

  @if (showCloseBtn) {
    <div class="feedback-action">
      <ui-asset
        name="close"
        [mkpDataTest]="dataTestConfig.closeButton"
        (click)="handleAction.emit()"
      />
    </div>
  } @else {
    @if (buttonConfig) {
      <ui-button
        [mkpDataTest]="dataTestConfig.cta"
        [state]="state"
        [config]="buttonConfig"
        (click)="handleAction.emit()"
      >
        {{ this.buttonText | translate }}
      </ui-button>
    }
  }
</div>
